import MusicVideoMetadataMismatchAuditTable from "../MusicAssetAuditComponents/MusicVideoMetadataMismatchAudit";

const MusicVideoMetadataRoute = () => {
  return <MusicVideoMetadataMismatchAuditTable />;
};

export default MusicVideoMetadataRoute;
